// CHG-131 REQ-CP-012: 공용 사용자 표시 이름
// - 닉네임 우선, 없으면 이름
// - showFullForm: '닉네임 (이름)' (닉네임 없으면 그냥 이름)
// - bold=true → font-bold, false → font-medium
// - color: getColorClasses(displayColor).textClass (700계)
// - onClick → cursor-pointer + hover:underline (button 시맨틱)
import {
  getColorClasses,
  pickColorByUserIdFallback,
  type ProfileColorKey,
} from '@maios/shared';

export interface UserDisplayNameProps {
  userId: string;
  name: string;
  nickname?: string | null;
  displayColor?: ProfileColorKey | null;
  bold?: boolean;
  showFullForm?: boolean;
  onClick?: () => void;
  className?: string;
}

export default function UserDisplayName({
  userId,
  name,
  nickname,
  displayColor,
  bold = false,
  showFullForm = false,
  onClick,
  className = '',
}: UserDisplayNameProps) {
  const colorKey: ProfileColorKey = displayColor ?? pickColorByUserIdFallback(userId);
  const palette = getColorClasses(colorKey);

  // 닉네임이 빈 문자열이면 fallback to name
  const nick = nickname?.trim() ? nickname.trim() : null;

  const label = showFullForm
    ? (nick ? `${nick} (${name})` : name)
    : (nick ?? name);

  const weight = bold ? 'font-bold' : 'font-medium';
  const interactClass = onClick ? 'cursor-pointer hover:underline' : '';
  const fullClass = `${palette.textClass} ${weight} ${interactClass} ${className}`.trim();

  return onClick ? (
    <button type="button" onClick={onClick} className={fullClass}>
      {label}
    </button>
  ) : (
    <span className={fullClass}>{label}</span>
  );
}
